import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Observable } from 'rxjs';
import { LinkableAccount } from '../../_models/fundraising/LinkableAccount';
import { MerchantService } from '../../_services/fundraising/merchant.service';
import { VendorService } from '../../_services/fundraising/vendor.service';

@Component({
  selector: 'app-fundraising-account-link-modal',
  templateUrl: './fundraising-account-link-modal.component.html',
  styleUrls: ['./fundraising-account-link-modal.component.css']
})
export class FundraisingAccountLinkModalComponent implements OnInit {

  public accountType;
  public accountId;

  public linkableAccounts: LinkableAccount[];

  @Output() hasError = new EventEmitter();

  constructor(
    private merchantService: MerchantService,
    private vendorService: VendorService,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit() {

    let linkableAccountsObs: Observable<LinkableAccount[]>;

    switch (this.accountType) {
      case 'merchant': 
        linkableAccountsObs = this.merchantService.getLinkedVendors(this.accountId); 
        break;
      case 'vendor':
        linkableAccountsObs = this.vendorService.getLinkedMerchants(this.accountId); 
        break;
    }

    linkableAccountsObs
      .subscribe(
        data => {
          this.linkableAccounts = data;        
        },
        error => {
          this.hasError.emit(true);
          this.bsModalRef.hide();
        }
      );
  }

  saveAndClose() {
  let updateLinkedAccountsObs: Observable<LinkableAccount[]>;

    switch (this.accountType) {
      case 'merchant': 
        updateLinkedAccountsObs = this.merchantService.updateLinkedVendors(this.accountId, this.linkableAccounts); 
        break;
      case 'vendor':
        updateLinkedAccountsObs = this.vendorService.updateLinkedMerchants(this.accountId, this.linkableAccounts);
        break;
    }

    updateLinkedAccountsObs
      .subscribe(
        () => { 
          this.close();
        },
        error => {
          this.hasError.emit(true);
          this.bsModalRef.hide();
        }
      );
  }

  close() {
    this.hasError.emit(false);
    this.bsModalRef.hide();
  }

}

